import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ColumnTextViewer } from '../../components/column-text-viewer/column-text-viewer';
import { SectionBanner } from '../../components/section-banner/section-banner';
import { SolutionsCard } from '../../components/solutions-card/solutions-card';
import { Page } from '../../data/interfaces/Page';
import { PAGESINS } from '../../data/sectors/inspections-pages.data';
import { PAGESPRIV } from '../../data/sectors/private-security-pages.data';
import { PAGESPUB } from '../../data/sectors/public-security-pages.data';

@Component({
  selector: 'app-first-template',
  imports: [SectionBanner, ColumnTextViewer, SolutionsCard],
  templateUrl: './first-template.html',
  styleUrl: './first-template.scss',
})


export class FirstTemplate {
  public page: any;
  public bannerContent: any;
  public textRows;
  public solution;
  sectorTypes: string[] = [
    'public-security',
    'private-security',
    'inspections'
  ]
  constructor(private route: ActivatedRoute, private router: Router) {
    const slug = this.route.snapshot.paramMap.get('slug')
    let typeOfSector = this.route.snapshot.url[1].path;

    let pageSelector: Page[];
    if (!this.sectorTypes.includes(typeOfSector) ) {
        this.router.navigate(['/404'])
    }

    switch (this.route.snapshot.url[1].path) {
      case 'public-security':
        pageSelector = PAGESPUB
        break;
      case 'private-security': 
        pageSelector = PAGESPRIV
        break;
      case 'inspections': 
        pageSelector = PAGESINS
        break;
      default: 
        this.router.navigate(['/404'])
        return;
    }
    
    
    this.page = pageSelector.find(p => p.slug == slug)
    
    this.bannerContent = {
      bannerImg: this.page.bannerImg,
      bannerTitle: this.page.title,
      bannerText: this.page.subtitle,
      bannerImgMobile: this.page.bannerImgMobile
    }

    this.textRows = this.page.rows;
    this.solution = this.page.solution;

    
  }

}
